import {
  GET_PRESSURE_GAUGE_INFOS_IN_PROGRESS,
  GET_PRESSURE_GAUGE_INFOS_SUCCESS,
  GET_PRESSURE_GAUGE_INFOS_FAIL,
  POST_PRESSURE_GAUGE_IN_PROGRESS,
  POST_PRESSURE_GAUGE_SUCCESS,
  POST_PRESSURE_GAUGE_FAIL,
  PUT_PRESSURE_GAUGE_IN_PROGRESS,
  PUT_PRESSURE_GAUGE_SUCCESS,
  PUT_PRESSURE_GAUGE_FAIL,
} from "../constants";

const initialState = {
  infos: undefined,
  saving: false,
  saved: false,
  errors: null,
};

/**
 * Pressure gauge reducer
 *
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function pressureGauge(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case GET_PRESSURE_GAUGE_INFOS_IN_PROGRESS:
      return {
        ...state,
        infos: undefined,
      };

    case GET_PRESSURE_GAUGE_INFOS_SUCCESS:
      return {
        ...state,
        infos: payload.infos,
      };

    case GET_PRESSURE_GAUGE_INFOS_FAIL:
      return {
        ...state,
        infos: null,
      };

    case POST_PRESSURE_GAUGE_IN_PROGRESS:
    case PUT_PRESSURE_GAUGE_IN_PROGRESS:
      return {
        ...state,
        saving: true,
        saved: false,
        errors: null,
      };

    case POST_PRESSURE_GAUGE_SUCCESS:
    case PUT_PRESSURE_GAUGE_SUCCESS:
      return {
        ...state,
        saving: false,
        saved: true,
      };

    case POST_PRESSURE_GAUGE_FAIL:
    case PUT_PRESSURE_GAUGE_FAIL:
      return {
        ...state,
        saving: false,
        saved: false,
        errors: payload.violations,
      };

    default:
      return state;
  }
}
